<template>
    <div>
        <StructuredData />
        <section class="section-profile-cover section-shaped my-0">
            <div class="shape shape-style-1 shape-primary shape-skew">
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
                <span></span>
            </div>
        </section>
        
        <section class="section section-skew">
            <div class="container">
                <card shadow class="card-profile mt--150" no-body>
                    <div class="px-4 py-5">
                        <div class="text-center mb-5">
                            <h1 class="display-3">Barrierefreiheit nach WCAG & BITV</h1>
                            <p class="lead">
                                Digitale Inklusion für alle Nutzer – rechtssicher und zukunftsfähig
                            </p>
                        </div>

                        <div class="row">
                            <div class="col-lg-8 mx-auto">
                                <div class="alert alert-warning mb-5">
                                    <strong>⚠️ Wichtig:</strong> Ab dem <strong>28. Juni 2025</strong> gilt das 
                                    <strong>Barrierefreiheitsstärkungsgesetz (BFSG)</strong> für viele digitale Produkte 
                                    und Dienstleistungen. Ist Ihre Website vorbereitet?
                                </div>

                                <h2>Was bedeutet digitale Barrierefreiheit?</h2>
                                <p>
                                    Barrierefreie Websites ermöglichen <strong>allen Menschen</strong> den Zugang zu 
                                    digitalen Inhalten – unabhängig von körperlichen oder kognitiven Einschränkungen. 
                                    Das betrifft etwa <strong>10% der Bevölkerung</strong> mit Sehbehinderungen, 
                                    Hörbeeinträchtigungen, motorischen Einschränkungen oder kognitiven Beeinträchtigungen.
                                </p>

                                <h3 class="mt-5">Relevante Standards & Gesetze</h3>
                                
                                <div class="row mt-4">
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-primary">
                                                    <icon name="ni ni-world-2" class="mr-2"></icon>
                                                    WCAG 2.1 / 2.2
                                                </h5>
                                                <p>
                                                    <strong>Web Content Accessibility Guidelines</strong> – 
                                                    der internationale Standard für barrierefreie Webinhalte. 
                                                    Stufen A, AA und AAA.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-success">
                                                    <icon name="ni ni-badge" class="mr-2"></icon>
                                                    BITV 2.0
                                                </h5>
                                                <p>
                                                    <strong>Barrierefreie-Informationstechnik-Verordnung</strong> – 
                                                    deutsche Umsetzung der EU-Richtlinie für öffentliche Stellen.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-warning">
                                                    <icon name="ni ni-book-bookmark" class="mr-2"></icon>
                                                    BFSG 2025
                                                </h5>
                                                <p>
                                                    <strong>Barrierefreiheitsstärkungsgesetz</strong> – 
                                                    seit Juni 2025 verpflichtend für viele private Unternehmen 
                                                    im B2C-Bereich.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                    
                                    <div class="col-md-6 d-flex">
                                        <card shadow class="mb-4 flex-fill">
                                            <div class="px-3 py-3">
                                                <h5 class="text-info">
                                                    <icon name="ni ni-planet" class="mr-2"></icon>
                                                    EN 301 549
                                                </h5>
                                                <p>
                                                    <strong>Europäische Norm</strong> – 
                                                    technischer Standard für barrierefreie IKT-Produkte 
                                                    und -Dienstleistungen.
                                                </p>
                                            </div>
                                        </card>
                                    </div>
                                </div>

                                <h3 class="mt-5">Unsere Barrierefreiheit-Leistungen</h3>
                                <ul class="list-unstyled mt-3">
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Accessibility Audit</strong> – Umfassende Prüfung nach WCAG 2.1 Level AA
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>BITV-Test</strong> – Zertifizierte Prüfung nach deutschem Standard
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Barrierefreie Entwicklung</strong> – Neuentwicklung oder Anpassung bestehender Websites
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Schulungen</strong> – Für Entwickler, Redakteure und Content-Manager
                                    </li>
                                    <li class="py-2">
                                        <icon name="ni ni-check-bold" class="text-success mr-2"></icon>
                                        <strong>Erklärung zur Barrierefreiheit</strong> – Erstellung der rechtlich erforderlichen Dokumente
                                    </li>
                                </ul>

                                <h3 class="mt-5">Die 4 Prinzipien der WCAG</h3>
                                <div class="row mt-4">
                                    <div class="col-6 col-lg-3 mb-4">
                                        <div class="text-center">
                                            <div class="icon icon-lg icon-shape bg-gradient-primary shadow rounded-circle mb-3">
                                                <i class="ni ni-glasses-2 text-white"></i>
                                            </div>
                                            <h6>Wahrnehmbar</h6>
                                            <p class="small">Inhalte müssen für alle Sinne zugänglich sein</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-lg-3 mb-4">
                                        <div class="text-center">
                                            <div class="icon icon-lg icon-shape bg-gradient-success shadow rounded-circle mb-3">
                                                <i class="ni ni-button-play text-white"></i>
                                            </div>
                                            <h6>Bedienbar</h6>
                                            <p class="small">Navigation und Interaktion für alle möglich</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-lg-3 mb-4">
                                        <div class="text-center">
                                            <div class="icon icon-lg icon-shape bg-gradient-warning shadow rounded-circle mb-3">
                                                <i class="ni ni-bulb-61 text-white"></i>
                                            </div>
                                            <h6>Verständlich</h6>
                                            <p class="small">Inhalte und Bedienung leicht verständlich</p>
                                        </div>
                                    </div>
                                    <div class="col-6 col-lg-3 mb-4">
                                        <div class="text-center">
                                            <div class="icon icon-lg icon-shape bg-gradient-info shadow rounded-circle mb-3">
                                                <i class="ni ni-settings text-white"></i>
                                            </div>
                                            <h6>Robust</h6>
                                            <p class="small">Kompatibel mit assistiven Technologien</p>
                                        </div>
                                    </div>
                                </div>

                                <h3 class="mt-5">Wer ist vom BFSG betroffen?</h3>
                                <p>Seit Juni 2025 müssen folgende Unternehmen ihre digitalen Angebote barrierefrei gestalten:</p>
                                <ul class="mt-3">
                                    <li>E-Commerce / Online-Shops</li>
                                    <li>Bankdienstleistungen</li>
                                    <li>E-Books und E-Reader</li>
                                    <li>Telekommunikationsdienste</li>
                                    <li>Personenbeförderungsdienste</li>
                                    <li>Öffentliche Stellen (bereits seit 2020)</li>
                                </ul>

                                <h3 class="mt-5">Technologien & Tools</h3>
                                <div class="mt-3">
                                    <badge type="primary" rounded class="mr-2 mb-2">WCAG 2.1</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">WCAG 2.2</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">BITV 2.0</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">ARIA</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Screenreader</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">axe DevTools</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">WAVE</badge>
                                    <badge type="primary" rounded class="mr-2 mb-2">Pa11y</badge>
                                </div>

                                <div class="text-center mt-5">
                                    <base-button
                                        tag="a"
                                        href="/#kontakt"
                                        type="primary"
                                        size="lg"
                                        icon="fa fa-envelope"
                                        @click.prevent="$router.push('/#kontakt')"
                                    >
                                        Barrierefreiheit-Audit anfragen
                                    </base-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </card>
            </div>
        </section>
    </div>
</template>

<script>
import StructuredData from '../components/StructuredData.vue'

export default {
    name: 'barrierefreiheit',
    components: {
        StructuredData
    },
    head: {
        title: {
            inner: 'Barrierefreiheit WCAG & BITV',
            separator: '|',
            complement: 'Web Services and More'
        },
        meta: [
            {
                name: 'description',
                content: 'Barrierefreiheit nach WCAG 2.1 & BITV 2.0 ✓ BFSG-konform seit 2025 ✓ Accessibility Audit ✓ Barrierefreie Webentwicklung ✓ DACH-Region ✓ Jetzt Audit anfragen!',
                id: 'desc'
            },
            {
                name: 'keywords',
                content: 'Barrierefreiheit, WCAG 2.1, BITV 2.0, BFSG, Accessibility, barrierefreie Website, Accessibility Audit, digitale Barrierefreiheit, EN 301 549, WCAG Konformität'
            },
            {
                property: 'og:title',
                content: 'Barrierefreiheit WCAG & BITV | Web Services and More'
            },
            {
                property: 'og:description',
                content: 'Barrierefreie Webentwicklung nach WCAG 2.1 und BITV 2.0. BFSG-konform seit 2025. Accessibility Audits und barrierefreie Entwicklung.'
            },
            {
                property: 'og:type',
                content: 'website'
            },
            {
                property: 'og:url',
                content: 'https://www.wsam.biz/barrierefreiheit'
            },
            {
                name: 'twitter:card',
                content: 'summary_large_image'
            },
            {
                name: 'twitter:title',
                content: 'Barrierefreiheit WCAG & BITV | Web Services and More'
            },
            {
                name: 'twitter:description',
                content: 'Barrierefreie Webentwicklung nach WCAG 2.1 und BITV 2.0. BFSG-konform seit 2025.'
            }
        ]
    }
}
</script>
